<template>
    <button @click="openSettingMenu($event)" type="button" class="settings-btn w-full md:hidden flex items-center justify-center gap-2 p-2 rounded bg-primary text-white">
        <span class="capitalize">{{ $t('menu.settings_menu') }}</span>
        <i class="icon fa-solid fa-chevron-down text-sm"></i>
    </button>
    <div class="menu-settings db-card h-0 overflow-hidden md:h-auto md:overflow-auto transition-all duration-300 font-medium">
        <nav class="p-3">
            <router-link v-if="isMenuVisible('company')" :to="{ name: 'admin.settings.company' }" class="db-tab-btn">
                <i class="lab lab-line-company text-sm"></i>
                {{ $t("menu.company") }}
            </router-link>
            <router-link v-if="isMenuVisible('site')" :to="{ name: 'admin.settings.site' }" class="db-tab-btn">
                <i class="lab lab-line-branches text-sm"></i>
                {{ $t("menu.store") }}
            </router-link>
            <router-link v-if="isMenuVisible('theme')" :to="{ name: 'admin.settings.theme' }" class="db-tab-btn">
                <i class="lab lab-line-theme text-sm"></i>
                {{ $t("menu.visual_theme") }}
            </router-link>
            <router-link v-if="isMenuVisible('social_media')" :to="{ name: 'admin.settings.socialMedia' }" class="db-tab-btn">
                <i class="lab lab-line-social text-sm"></i>
                {{ $t("menu.social_media") }}
            </router-link>
            <router-link v-if="isMenuVisible('cookies')" :to="{ name: 'admin.settings.cookies' }" class="db-tab-btn">
                <i class="lab lab-line-cookies text-sm"></i>
                {{ $t("menu.cookies") }}
            </router-link>
            <router-link v-if="isMenuVisible('otp')" :to="{ name: 'admin.settings.otp' }" class="db-tab-btn">
                <i class="lab lab-line-otp text-sm"></i>
                {{ $t("menu.otp") }}
            </router-link>
            <router-link v-if="isMenuVisible('mail')" :to="{ name: 'admin.settings.mail' }" class="db-tab-btn">
                <i class="lab lab-line-mail text-sm"></i>
                {{ $t("menu.mail") }}
            </router-link>
            <router-link v-if="isMenuVisible('shipping_setup')" :to="{ name: 'admin.settings.shippingSetup' }" class="db-tab-btn">
                <i class="lab lab-line-truck-check text-sm"></i>
                {{ $t("menu.shipping_setup") }}
            </router-link>
            <router-link v-if="isMenuVisible('ai_import_settings')" :to="{ name: 'admin.settings.aiImportSetting' }" class="db-tab-btn">
                <i class="lab lab-line-settings text-sm"></i>
                {{ $t("menu.ai_import_settings") }}
            </router-link>
            <router-link v-if="isMenuVisible('whatsapp')" :to="{ name: 'admin.settings.whatsapp' }" class="db-tab-btn">
                <i class="lab lab-whatsapp text-sm"></i>
                {{ $t("menu.whatsapp_order_setup") }}
            </router-link>
            <router-link v-if="isMenuVisible('notification')" :to="{ name: 'admin.settings.notification' }" class="db-tab-btn">
                <i class="lab lab-line-notification text-sm"></i>
                {{ $t("menu.push_notifications") }}
            </router-link>
            <router-link v-if="isMenuVisible('notification_alert')" :to="{ name: 'admin.settings.notificationAlert' }" class="db-tab-btn">
                <i class="lab lab-line-notification-alert text-sm"></i>
                {{ $t("menu.notification_alert") }}
            </router-link>
            <router-link v-if="isMenuVisible('sms_gateway')" :to="{ name: 'admin.settings.smsGateway' }" class="db-tab-btn">
                <i class="lab lab-line-sms text-sm"></i>
                {{ $t("menu.sms_gateway") }}
            </router-link>
            <router-link v-if="isMenuVisible('payment_gateway')" :to="{ name: 'admin.settings.paymentGateway' }" class="db-tab-btn">
                <i class="lab lab-line-payment-gateway text-sm"></i>
                {{ $t("menu.payment_gateway") }}
            </router-link>
            <router-link v-if="isMenuVisible('shipping_gateway')" :to="{ name: 'admin.settings.shippingGateway' }" class="db-tab-btn">
                <i class="lab lab-line-truck-check text-sm"></i>
                {{ $t("menu.shipping_gateway") }}
            </router-link>
            <router-link v-if="isMenuVisible('ai_provider_settings')" :to="{ name: 'admin.settings.aiProviderSetting' }" class="db-tab-btn">
                <i class="lab lab-line-addons text-sm"></i>
                {{ $t("menu.ai_provider_settings") }}
            </router-link>
            <router-link v-if="isMenuVisible('product_categories')" :to="{ name: 'admin.settings.productCategory' }" class="db-tab-btn">
                <i class="lab lab-line-item-categories text-sm"></i>
                {{ $t("menu.product_categories") }}
            </router-link>
            <router-link v-if="isMenuVisible('product_attributes')" :to="{ name: 'admin.settings.productAttribute' }" class="db-tab-btn">
                <i class="lab lab-line-item-attributes text-sm"></i>
                {{ $t("menu.product_attributes") }}
            </router-link>
            <router-link v-if="isMenuVisible('units')" :to="{ name: 'admin.settings.unit' }" class="db-tab-btn">
                <i class="lab lab-line-unit text-sm"></i>
                {{ $t("menu.units") }}
            </router-link>
            <router-link v-if="isMenuVisible('product_brands')" :to="{ name: 'admin.settings.productBrand' }" class="db-tab-btn">
                <i class="lab lab-line-brand text-sm"></i>
                {{ $t("menu.product_brands") }}
            </router-link>
            <router-link v-if="isMenuVisible('suppliers')" :to="{ name: 'admin.settings.supplier' }" class="db-tab-btn">
                <i class="lab lab-line-supplier text-sm"></i>
                {{ $t("menu.suppliers") }}
            </router-link>
            <router-link v-if="isMenuVisible('outlets')" :to="{ name: 'admin.settings.outlet' }" class="db-tab-btn">
                <i class="lab lab-line-branches text-sm"></i>
                {{ $t("menu.outlets") }}
            </router-link>
            <router-link v-if="isMenuVisible('benefits')" :to="{ name: 'admin.settings.benefit' }" class="db-tab-btn">
                <i class="lab lab-line-benefits text-sm"></i>
                {{ $t("menu.benefits") }}
            </router-link>
            <router-link v-if="isMenuVisible('return_reasons')" :to="{ name: 'admin.settings.returnReason' }" class="db-tab-btn">
                <i class="lab lab-line-order-setup text-sm"></i>
                {{ $t("menu.return_reasons") }}
            </router-link>
            <router-link v-if="isMenuVisible('taxes')" :to="{ name: 'admin.settings.tax' }" class="db-tab-btn">
                <i class="lab lab-line-taxes text-sm"></i>
                {{ $t("menu.taxes") }}
            </router-link>
            <router-link v-if="isMenuVisible('sliders')" :to="{ name: 'admin.settings.slider' }" class="db-tab-btn">
                <i class="lab lab-line-sliders text-sm"></i>
                {{ $t("menu.sliders") }}
            </router-link>
            <router-link v-if="isMenuVisible('pages')" :to="{ name: 'admin.settings.page' }" class="db-tab-btn">
                <i class="lab lab-line-pages text-sm"></i>
                {{ $t("menu.pages") }}
            </router-link>
            <router-link v-if="isMenuVisible('analytics')" :to="{ name: 'admin.settings.analytic' }" class="db-tab-btn">
                <i class="lab lab-line-analytic text-sm"></i>
                {{ $t("menu.analytics") }}
            </router-link>
            <router-link v-if="isMenuVisible('currencies')" :to="{ name: 'admin.settings.currency' }" class="db-tab-btn">
                <i class="lab lab-line-currencies text-sm"></i>
                {{ $t("menu.currencies") }}
            </router-link>
            <router-link v-if="isMenuVisible('languages')" :to="{ name: 'admin.settings.language' }" class="db-tab-btn">
                <i class="lab lab-line-global text-sm"></i>
                {{ $t("menu.languages") }}
            </router-link>
            <router-link v-if="isMenuVisible('location_setup')" :to="{ name: 'admin.settings.locationSetup' }" class="db-tab-btn">
                <i class="lab lab-line-location-setup text-sm"></i>
                {{ $t("menu.location_setup") }}
            </router-link>
            <router-link v-if="isMenuVisible('pwa')" :to="{ name: 'admin.settings.pwa' }" class="db-tab-btn">
                <i class="lab lab-monitor-mobbile text-sm"></i>
                {{ $t("menu.progressive_web_app") }}
            </router-link>
            <router-link v-if="isMenuVisible('role_permissions')" :to="{ name: 'admin.settings.role' }" class="db-tab-btn">
                <i class="lab lab-line-role-permission text-sm"></i>
                {{ $t("menu.role_permissions") }}
            </router-link>
            <router-link v-if="isMenuVisible('system')" :to="{ name: 'admin.settings.system' }" class="db-tab-btn">
                <i class="lab lab-line-settings text-sm"></i>
                {{ $t("label.system_and_maintenance") }}
            </router-link>
            <router-link v-if="isMenuVisible('license')" :to="{ name: 'admin.settings.license' }" class="db-tab-btn">
                <i class="lab-line-license-code text-sm"></i>
                {{ $t("menu.license") }}
            </router-link>
        </nav>
    </div>
</template>

<script>
import axios from "axios";
import appService from "../../../services/appService";
export default {
    name: "MenuComponent",

    data() {
        return {
            menuVisibility: {
                company: true,
                site: true,
                theme: true,
                social_media: true,
                cookies: true,
                otp: true,
                mail: true,
                shipping_setup: true,
                whatsapp: true,
                ai_import_settings: true,
                notification: true,
                notification_alert: true,
                sms_gateway: true,
                payment_gateway: true,
                shipping_gateway: true,
                ai_provider_settings: true,
                product_categories: true,
                product_attributes: true,
                units: true,
                product_brands: true,
                suppliers: true,
                outlets: true,
                benefits: true,
                return_reasons: true,
                taxes: true,
                sliders: true,
                pages: true,
                analytics: true,
                currencies: true,
                languages: true,
                location_setup: true,
                pwa: true,
                role_permissions: true,
                system: true,
                license: true,
            }
        };
    },

    mounted() {
        this.fetchMenuSettings();
    },

    methods: {
        openSettingMenu: function (event) {
            return appService.openSettingMenu(event);
        },

        isMenuVisible: function (key) {
            return this.menuVisibility[key] !== false;
        },

        fetchMenuSettings: function () {
            axios.get('admin/setting/menu-settings').then((res) => {
                this.menuVisibility = {
                    ...this.menuVisibility,
                    ...(res?.data?.data || {}),
                };
            }).catch(() => {
                // Keep defaults (all visible) if endpoint fails.
            });
        },
 }
};
</script>
